import React, {PropTypes as T} from 'react';
import withDevice from '../../common/withDeviceHOC';
import Modal, {ModalContent, ModalFooter} from '../../common/modal';
import InfoHeader from '../../common/modal/closeable_info_header';
import Button from '../../common/button';
import TU from '../../common/tu';
import modalActions from '../../../actions/modal';

class AdditionalInfoContent extends React.Component {
  static propTypes = {
    modal: T.object,
    isMobile: T.bool
  };

  renderTopics = (topics) => {
    return topics.map(topic => {
      return <div key={topic.id}>
        <h2>{topic.name}</h2>
        <TU text={topic.description} />
      </div>;
    });
  };

  render () {
    return (
      <Modal
        isOpen={this.props.modal.showModal}
        onClose={modalActions.hide}
        dataComponent="information-lightbox">
        <InfoHeader
          onClose={modalActions.hide}
          title={this.props.modal.translations.INFORMATION_LIGHTBOX_ADDITIONAL_INFO_HEADER} />
        <ModalContent>
          {this.renderTopics(this.props.modal.informationLightbox.infoTopics)}
        </ModalContent>

        <ModalFooter>
          <Button
            primary
            flex={this.props.isMobile}
            onClick={modalActions.hide}
            data-component="modal-continue-button"
          >
            {this.props.modal.translations.INFORMATION_LIGHTBOX_CONTINUE_BUTTON}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(AdditionalInfoContent);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/additional_info_content.js